import { ButtonSizes, ContentField, LinkAsButton, Typography } from '@/shared/ui';

import { config } from '@/config/index';

import { ROUTES } from '@/router/baseRoutes';

import './SocialProtectNoData.scss';

interface Props {
  socialProtectLink: string;
}

export const SocialProtectNoData: React.FC<Props> = ({ socialProtectLink }) => {
  return (
    <ContentField
      className="social-protect-no-data"
      icon="no_result"
      content={
        <div className="social-protect-no-data__wrapper">
          <div>
            <Typography variant="H4">Ми не знайшли ваші дані в базі</Typography>
            <Typography color="graphite">
              Якщо ви є особою, яка має право на отримання послуг в рамках соціального захисту МВС - зателефонуйте, будь
              ласка, для вирішення цього питання за коротким номером:
            </Typography>
            <Typography variant="H2">{config.support.mvsNumber}</Typography>
            <Typography color="graphite">(Пн-Сб, 9.00-18.00)</Typography>
          </div>
          <div className="social-protect-no-data__buttons-block">
            <LinkAsButton size={ButtonSizes.LG} to={ROUTES.HOME}>
              На головну сторінку
            </LinkAsButton>

            <LinkAsButton isExternal size={ButtonSizes.LG} to={socialProtectLink}>
              МВС: Твоя підтримка
            </LinkAsButton>
          </div>
        </div>
      }
    />
  );
};
